import { NAMESPACE } from './constants'

export const status = state => state[NAMESPACE].status
export const error = state => state[NAMESPACE].error
export const list = state => state[NAMESPACE].list